import React, { useState } from "react";
import "../Css/accordion.css";
let envItems = [
  {
    "id": "q1", "title": "¿Tener una página web realmente aumenta las ventas?", "content": "**Sí, definitivamente.** Actualmente, la mayoría de los consumidores inicia su búsqueda en internet. Contar con una página web bien diseñada permite que su negocio se destaque, transmita profesionalismo y genere la confianza necesaria en sus clientes potenciales. Esto se traduce en un **aumento significativo de visitas, consultas y, en consecuencia, de ventas.**"
  },
  {
    "id": "q2", "title": "¿Cuáles son los costos fijos de mantener una página web?", "content": "Los constos normalmente incluyen el dominio (aprox. 10-25 USD al año), el hosting (desde 7 USD al mes en adelante) y el mantenimiento del sofware (desde 5 USD al mes en adelante)."
  },
  {
    "id": "q3", "title": "¿Cuánto cuesta diseñar una página web profesional?", "content": "Depende del alcance y complejidad. Un diseño básico puede costar desde 150 USD, mientras que un desarrollo a medida con funcionalidades avanzadas puede superar los 1,000 USD."
  },
  {
    "id": "q4", "title": "¿Cuánto tiempo tarda en desarrollarse una web?", "content": "Una Web básica puede estar lista en 1-2 semanas. Proyectos con personalización, integración de sistemas o un E-comerce pueden tardar de 4 a 8 semanas."
  },
  {
    "id": "q5", "title": "¿Necesito mantenimiento constante para mi web?", "content": "Sí, aunque el mantenimiento básico es sencillo. Implica actualizar el contenido, revisar la seguridad y hacer pequeñas mejoras. Con un plan de mantenimiento, tu web estará siempre segura y actualizada."
  }
];

export default function Accordion({ items, multiple = false, defaultOpen = [], className = "" }) {
  const finalItems = Array.isArray(items) && items.length > 0 ? items : envItems;

  const init = Array.isArray(defaultOpen) ? defaultOpen : (defaultOpen != null ? [defaultOpen] : []);
  const [openIndexes, setOpenIndexes] = useState(() => new Set(init));

  const toggleIndex = (i) => {
    setOpenIndexes((prev) => {
      const next = new Set(prev);
      if (next.has(i)) {
        next.delete(i);
      } else {
        if (!multiple) next.clear();
        next.add(i);
      }
      return next;
    });
  };

  const handleKey = (e, i) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleIndex(i);
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const next = Math.min(finalItems.length - 1, i + 1);
      document.getElementById(`acc-btn-${next}`)?.focus();
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const prev = Math.max(0, i - 1);
      document.getElementById(`acc-btn-${prev}`)?.focus();
    }
    if (e.key === "Home") {
      e.preventDefault();
      document.getElementById("acc-btn-0")?.focus();
    }
    if (e.key === "End") {
      e.preventDefault();
      document.getElementById(`acc-btn-${finalItems.length - 1}`)?.focus();
    }
  };

  return (
    finalItems !== null && (
      <div className={`ClustTec-accordion ${className}`}>
        <h1 className="acc-main-title">Preguntas Frecuentes</h1>
        {finalItems.map((it, i) => {
          const isOpen = openIndexes.has(i);
          const panelId = `acc-panel-${i}`;
          const btnId = `acc-btn-${i}`;
          return (
            <div className="acc-item" key={it.id ?? i}>
              <h3 className="acc-head">
                <button
                  id={btnId}
                  aria-controls={panelId}
                  aria-expanded={isOpen}
                  className={`acc-trigger ${isOpen ? "open" : ""}`}
                  onClick={() => toggleIndex(i)}
                  onKeyDown={(e) => handleKey(e, i)}
                >
                  <span className="acc-title">{it.title}</span>
                  <span className="acc-icon" aria-hidden>
                    <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
              </h3>
              <div
                id={panelId}
                role="region"
                aria-labelledby={btnId}
                className={`acc-panel ${isOpen ? "open" : ""}`}
              >
                <div
                  className="acc-panel-inner"
                  dangerouslySetInnerHTML={{
                    __html: it.content.replace(/\*\*(.*?)\*\*/g, "<em><strong>$1</strong></em>")
                  }} />
              </div>
            </div>
          );
        })
        }
      </div >
    )
  );
}
